import React from 'react';
import { GovIcon } from '@gov-design-system-ce/react';
import { MarkdownRender } from '@gov-nx/component/web';
import type { CookbookItemCoreProps } from '@gov-nx/ui/types';

export const CookbookItem = ({ icon, copy }: CookbookItemCoreProps) => (
	<li>
		<span className="inline-flex gap-(--spacing-s-nudge) px-(--spacing-m) py-(--spacing-s) rounded-lg bg-(--background-block-primary)">
			{icon ? (
				<GovIcon
					name={icon.name}
					type={icon.type}
					size="l"
					className="relative top-0.5"
				/>
			) : null}
			<span className="text-body-l">
				<MarkdownRender>{copy}</MarkdownRender>
			</span>
		</span>
	</li>
);
